import BaseComponent from "../../../../../lib/components/BaseComponent";
import button from "../../../components/buttons/Button";
import ChangelogEntry from "./ChangelogEntry";

class ChangelogButton extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  toggleDetailDialog = (e) => {
    if (e.target.tagName !== 'A') {
      e.preventDefault();
      this.setState({open: !this.state.open});
    }
  }

  render() {
    return <div className="flex items-center justify-center text-slate-100 mr-7">
      <details className="relative group" id="changelog" open={this.state.open} onClick={this.toggleDetailDialog}>
        <summary className="flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer bg-white/5 backdrop-blur-md shadow-lg shadow-black/40 hover:-translate-y-1 transition-all duration-200">
              <span className="flex items-center justify-center w-7 h-7 rounded-md bg-white/5 shadow-inner">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"
                     stroke-linejoin="round" viewBox="0 0 24 24">
                    <rect x="3" y="4" width="18" height="18" rx="2"></rect>
                    <path d="M8 7h8M8 12h8M8 17h5"></path>
                  </svg>
                </span>
          <span className="leading-tight">
                  <span className="font-semibold">ChangeLog</span>
                  <span className="block text-xs text-white -mt-0.5">Letzte Änderungen</span>
                </span>
          <span className="ml-1 text-xs font-bold text-white bg-cn-color-primary px-2 py-0.5 rounded-full shadow-md shadow-indigo-500/30">2</span>
        </summary>

        <div
          className="absolute right-0 mt-3 w-80 rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 shadow-xl shadow-black/50 p-4 animate-in fade-in slide-in-from-top-2">
          <h4 className="text-sm font-semibold mb-3">Neueste Änderungen</h4>

          <ChangelogEntry title='Dynamischer Massenmailversand' description='Empfängerliste ab Versandzeitpunkt'/>
          <ChangelogEntry title='Neues UI mit MUI' description='Benutzeroberfläche neu mit MUI'/>

          <div className="flex justify-between mt-4">
            <button onClick={this.toggleDetailDialog}
                    className="text-xs px-3 py-1 rounded-lg bg-white/5 hover:bg-white/10 text-slate-300 transition">
              Schließen
            </button>

            <a href="/changelog"
               className="text-xs px-3 py-1 rounded-lg bg-cn-color-primary hover:bg-cn-color-primary-hover text-black shadow-md shadow-indigo-500/30 transition">
              Komplettes Changelog
            </a>
          </div>
        </div>
      </details>
    </div>
  }
}
export default ChangelogButton;
